import React from 'react';
import { Shield, Users, Calendar, Newspaper, LogOut, Settings } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import EventsCard from './EventsCard';

const AdminDashboard = ({
  posts,
  newPost,
  setNewPost,
  loading,
  addPost,
  showNotification
}) => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    showNotification('Logged out successfully', 'success');
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <Shield size={32} className="admin-icon" />
            <div>
              <h1 className="admin-title">Admin Dashboard</h1>
              <p className="admin-subtitle">Manage your church website content</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-outline admin-logout"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      </div>

      <div className="admin-content">
        <div className="admin-stats">
          <div className="admin-stat-card">
            <div className="admin-stat-icon">
              <Calendar size={24} />
            </div>
            <div className="admin-stat-info">
              <h3>Events</h3>
              <p>Manage church events</p>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="admin-stat-icon">
              <Newspaper size={24} />
            </div>
            <div className="admin-stat-info">
              <h3>Newsletter</h3>
              <p>Manage announcements</p>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="admin-stat-icon">
              <Users size={24} />
            </div>
            <div className="admin-stat-info">
              <h3>Contact</h3>
              <p>View messages</p>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="admin-stat-icon">
              <Settings size={24} />
            </div>
            <div className="admin-stat-info">
              <h3>Settings</h3>
              <p>Site configuration</p>
            </div>
          </div>
        </div>

        <div className="admin-panels">
          <div className="admin-panel">
            <EventsCard />
          </div>

          <div className="admin-panel">
            <div className="card">
              <div className="card-header">
                <Newspaper size={32} className="card-icon" />
                <h2 className="card-title">Quick Post</h2>
              </div>

              <div className="newsletter-form">
                <div className="form-group">
                  <label className="form-label">Title:</label>
                  <input
                    type="text"
                    value={newPost.title}
                    onChange={(e) => setNewPost({ ...newPost, title: e.target.value })}
                    placeholder="Enter announcement title"
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Content:</label>
                  <textarea
                    value={newPost.content}
                    onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
                    rows="3"
                    placeholder="Enter your announcement..."
                    className="form-textarea"
                  />
                </div>

                <button
                  onClick={async () => {
                    const success = await addPost(newPost);
                    if (success) {
                      setNewPost({ title: '', content: '' });
                    }
                  }}
                  disabled={loading}
                  className="btn btn-primary"
                >
                  {loading ? 'Adding...' : 'Add Post'}
                </button>
              </div>

              {posts.length > 0 && (
                <div>
                  <h3 className="newsletter-posts-title">Recent Posts</h3>
                  <div className="admin-posts-list">
                    {posts.slice(0, 3).map(post => (
                      <div key={post._id} className="admin-post-item">
                        <h4>{post.title}</h4>
                        <p>{post.content.substring(0, 100)}...</p>
                        <span className="admin-post-date">
                          {new Date(post.createdAt).toLocaleDateString()}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="admin-help">
          <div className="card">
            <div className="card-header">
              <Settings size={32} className="card-icon" />
              <h2 className="card-title">Admin Help</h2>
            </div>

            <div className="admin-help-content">
              <h3>Quick Actions:</h3>
              <ul>
                <li><strong>Events:</strong> Add, edit, or delete upcoming church events</li>
                <li><strong>Posts:</strong> Create announcements and newsletter content</li>
                <li><strong>Security:</strong> Remember to logout when finished</li>
              </ul>

              <h3>Tips:</h3>
              <ul>
                <li>Use descriptive titles for better organization</li>
                <li>Set proper dates and times for events</li>
                <li>Keep announcements concise and clear</li>
                <li>Regularly review and update content</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;